import { createRestApi } from '~/App/Api/rest';

export interface ReportResponse {
  message: string;
}

export const reportGreet = (greetId: string, body: Record<string, unknown>) =>
  createRestApi<ReportResponse>(`/api/v3/report/greet/${greetId}`).post(body);

export const reportRecording = (
  recordingId: string,
  body: Record<string, unknown>
) =>
  createRestApi<ReportResponse>(`/api/v3/report/recording/${recordingId}`).post(
    body
  );
